










import {defineComponent} from "@vue/composition-api"

export default defineComponent({
    name: "Navigation",
    props: {
        ariaLabel: {
            type: String,
            required: true,
            default: ""
        }
    }
})
